define('../app/fukit/behavior/table.sort.behavior',['require','exports','module','underscore','backbone','marionette','uikit/uikit','evicommon/spf/model/sort'],function(require, exports, module) {
  //prettier-ignore
  var _         = require('underscore'),
      Backbone  = require('backbone'),
      Mn        = require('marionette'),
      UIKit     = require('uikit/uikit'),
      SortModel = require('evicommon/spf/model/sort');

  var TableSortBehavior = Mn.Behavior.extend({
    defaults: {
      modelSortFieldAttribute: SortModel.SORT_FIELD,
      modelSortDirectionAttribute: SortModel.SORT_DIRECTION,
      viewSortFieldOption: 'sortField',
      viewSortDirectionOption: 'sortDir',
    },

    initialize: function() {
      _.defer(
        _.bind(function() {
          this.bindTableViewSortBindings();
          this.setupInitialSortValues();
          this.listenTo(this.view, 'change:collection', function() {
            this.bindTableViewSortBindings();
          });
        }, this)
      );
    },

    setupInitialSortValues: function() {
      if (this._didSetupInitialSortValues) {
        return;
      }

      var sortModel = this.getSortModel();

      if (!sortModel) {
        return;
      }

      this._didSetupInitialSortValues = true;

      var sortField = this.getSortModelOrViewProperty(
        this.getOption('modelSortFieldAttribute'),
        this.getOption('viewSortFieldOption')
      );
      var sortDirection = this.getSortModelOrViewProperty(
        this.getOption('modelSortDirectionAttribute'),
        this.getOption('viewSortDirectionOption')
      );

      if (sortField) {
        sortModel.set(this.getOption('modelSortFieldAttribute'), sortField);
      }
      if (sortDirection) {
        sortModel.set(this.getOption('modelSortDirectionAttribute'), sortDirection);
      }
    },

    bindTableViewSortBindings: function() {
      var sortModel = this.getSortModel();

      if (!sortModel || !this.view._bindBinding) {
        return;
      }

      var ev = _.extend({}, Backbone.Events);

      ev.listenTo(this.view, 'change:collection before:destroy', function() {
        ev.stopListening();
      });

      this.view._bindBinding(
        ev,
        this.view,
        this.getOption('viewSortFieldOption'),
        sortModel,
        this.getOption('modelSortFieldAttribute')
      );
      this.view._bindBinding(
        ev,
        this.view,
        this.getOption('viewSortDirectionOption'),
        sortModel,
        this.getOption('modelSortDirectionAttribute')
      );
    },

    getSortModel: function() {
      var collection = this.view.getOption('collection');

      if (!collection || !(collection.sort instanceof Backbone.Model)) {
        return;
      }

      return collection.sort;
    },

    getSortModelOrViewProperty: function(modelAttr, viewOption) {
      var sortModel = this.getSortModel();
      if (!sortModel) {
        return;
      }
      return sortModel.get(modelAttr) || this.view[viewOption];
    },
  });

  module.exports = TableSortBehavior;
});

